<template>
    <div v-if="selectedPaymentMethod">
        <font-awesome-icon icon="far fa-money-check" class="pr-3"/>
        {{ getText }}
    </div>
</template>

<script>
export default {
    name: 'StripeSepaInfo',
    props: {
        selectedPaymentMethod: {
            type: Object,
            required: true
        }
    },
    computed: {
        getText() {
            return this.selectedPaymentMethod ? `SEPA, ${this.$t('co.payment_methods.sepa.last4')} ${this.selectedPaymentMethod.sepa_debit.last4}, ${this.$t('co.payment_methods.sepa.owner')} ${this.selectedPaymentMethod.billing_details.name}` : ''
        }
    }
}
</script>
